"use client";

import { useEffect } from "react";

/**
 * The room under the dock is one level, published here on the document
 * root: the ten layouts and the home's column wear it through dockPad
 * (pb-[var(--site-dock-pad,7rem)], home-flags.ts). Only the Dock knows
 * what it hosts. With the Line on, the ball's stage (the dock's bottom
 * offset, then the 84 px ball, its 40 px row, the dock's py-2 and 24 px of
 * air: 176 px, the figure the home's work box pads inside by too), whatever
 * the door says: the stage already clears the box, and a pad that followed
 * the door would shorten the document by 80 px on open and jump a page
 * scrolled to its end. With the Line off (the flag, or the desktop shell,
 * where useLineOn is false), the box's room: the box is ~116 px tall by
 * its own classes, plus the same air, 140 px (the shipped pb-28 was the
 * 52 px compact pill's). Gone where the dock is hidden and on unmount, so
 * the class's fallback (7rem, the room of a build without the Dock) takes
 * over. One effect, no state, never re-run by the door. While the
 * floating Dock stands in for this one there is no box to clear: no room
 * at all, not the fallback's.
 */
export function useDockPad(
  dockVisible: boolean,
  floatingDock: boolean,
  liveOn: boolean,
  ballUp: boolean
): void {
  useEffect(() => {
    if (!dockVisible && !floatingDock) return;
    document.documentElement.style.setProperty(
      "--site-dock-pad",
      floatingDock
        ? "0px"
        : liveOn
          ? ballUp
            ? "calc(var(--site-dock-bottom) + 124px)"
            : "calc(var(--site-dock-bottom) + 100px)"
          : "calc(var(--site-dock-bottom) + 140px)"
    );
    return () => {
      document.documentElement.style.removeProperty("--site-dock-pad");
    };
  }, [dockVisible, floatingDock, liveOn, ballUp]);
}
